<svg viewBox="0 0 14 15" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_11557_149819)">
<path d="M11.1731 0.5H3.09615C2.35268 0.5 1.75 1.08762 1.75 1.8125V14.5L7.13462 11.4375L12.5192 14.5V1.8125C12.5192 1.08762 11.9165 0.5 11.1731 0.5ZM11.1731 12.2149L7.13462 9.91801L3.09615 12.2149V1.97656C3.09615 1.93305 3.11388 1.89132 3.14544 1.86055C3.177 1.82979 3.2198 1.8125 3.26442 1.8125H11.0048C11.0977 1.8125 11.1731 1.88586 11.1731 1.97645V12.2149Z" />
</g>
<defs>
<clipPath id="clip0_11557_149819">
<rect transform="translate(0 0.5)"/>
</clipPath>
</defs>
</svg>
